<template>
  <el-table-column
    prop="cash_net"
    label="Nettó kiszámlázás"
    align="right"
    width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.transfer_net | currency }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'unit_purchase_price',
};
</script>
